module.exports = __webpack_public_path__ + "static/ipvfull-35fad6d0baba875b3f09d573855f2159.jpg";